import styled from 'styled-components';
import { FONTS } from '@app/src/ui';

export const Title = styled.h4``;

export const IconCardWrapper = styled.span`
  margin: 30px 0 5px;
  display: inline-block;
`;

export const Message = styled.p``;

export const Content = styled.div`
  font-family: ${FONTS.OPEN_SANS};
  font-size: 18px;
  background: #fff;
  border-radius: 4px;
  min-height: 157px;
  padding: 0 21px 25px;
  text-align: center;
`;
